import React, { Component } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";

// Components
import AdminLoginForm from "./AdminLoginForm";

// CSS
import "../../../css/login.css";

class AdminLogin extends Component {
	render() {
		let title = "";
		if (this.props.siteInfo.site) {
			title += this.props.siteInfo.site.title + " | ";
		}
		title += "Admin Login";

		// Show meta tags
		const helmet = (
			<Helmet>
				<title>{title}</title>
			</Helmet>
		);

		return (
			<div className="body_container padded_top padded_bottom">
				{helmet}

				<main>
					<h1>Admin Login</h1>

					<AdminLoginForm />
				</main>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo
	};
};

export default connect(mapStateToProps)(AdminLogin);



// WEBPACK FOOTER //
// ./src/components/admin/login/AdminLogin.js